const getRouting = (reduxState: any) => reduxState.routing
const getLocationBeforeTransitions = (reduxState: any) => getRouting(reduxState).locationBeforeTransitions || { pathname: "" }
export const getCurrentPathName = (reduxState: any): string => getLocationBeforeTransitions(reduxState).pathname;